import { createNotification, getAllUsers } from '../services/firebaseService';

// Test function to create a sample mention notification
export const createTestMentionNotification = async (currentUserId, mentionedUserId) => {
  try {
    console.log('Creating test mention notification');
    console.log('Current user ID:', currentUserId);
    console.log('Mentioned user ID:', mentionedUserId);
    
    const testNotification = {
      userId: mentionedUserId,
      type: 'message_mention',
      title: 'You were mentioned in a message',
      message: 'Test User mentioned you: "This is a test mention notification"',
      taskId: 'test-task-id',
      taskName: 'Test Task',
      activityId: 'test-activity-id',
      activityName: 'Test Activity',
      projectId: 'test-project-id',
      projectName: 'Test Project',
      messageId: 'test-message-id',
      mentionedBy: 'Test User',
      mentionedByPhotoURL: 'https://ui-avatars.com/api/?name=Test%20User&background=e5e7eb&color=374151'
    };
    
    console.log('Test mention notification data:', testNotification);
    const notificationId = await createNotification(testNotification);
    console.log('Test mention notification created with ID:', notificationId);
    return notificationId;
  } catch (error) {
    console.error('Error creating test mention notification:', error);
    throw error;
  }
};

// Test function to verify user matching with multiple patterns
export const testUserMatching = async (mentionText) => {
  try {
    console.log('Testing user matching for mention:', mentionText);
    const users = await getAllUsers();
    console.log('Available users:', users);
    
    // Test all patterns like in TaskMessaging component
    const patterns = [
      // Pattern 1: @"Full Name With Spaces" (quoted names)
      /@"([^"]+)"/g,
      // Pattern 2: @FullNameWithoutSpaces or @email
      /@([^\s@"]+)/g,
      // Pattern 3: @Full Name (unquoted multi-word names until space or end)
      /@([A-Za-z]+(?:\s+[A-Za-z]+)*?)(?=\s(?!@)|$|[.!?])/g
    ];
    
    const matches = [];
    const testMessage = `@${mentionText}`;
    
    patterns.forEach((regex, index) => {
      console.log(`Testing pattern ${index + 1}:`, regex);
      let match;
      while ((match = regex.exec(testMessage)) !== null) {
        const extractedText = match[1].trim();
        console.log('Found mention pattern:', extractedText);
        
        const mentionedUser = users.find(user => {
          const mentionTextLower = extractedText.toLowerCase();
          const displayName = user.displayName?.toLowerCase() || '';
          const email = user.email?.toLowerCase() || '';
          
          return displayName === mentionTextLower || 
                 email === mentionTextLower ||
                 displayName.includes(mentionTextLower) ||
                 email.startsWith(mentionTextLower) ||
                 mentionTextLower.includes(displayName) ||
                 mentionTextLower.includes(email.split('@')[0]);
        });
        
        if (mentionedUser && !matches.find(m => m.id === mentionedUser.id)) {
          matches.push(mentionedUser);
        }
      }
    });
    
    console.log('Matched users:', matches);
    return matches;
  } catch (error) {
    console.error('Error testing user matching:', error);
    throw error;
  }
};

// Add test functions to window for easy access in console
if (typeof window !== 'undefined') {
  window.testMentions = {
    createTest: createTestMentionNotification,
    testMatching: testUserMatching
  };
}